export default __webpack_public_path__ + "static/media/number4.b38d89df.svg";